import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { FormControl, FormGroup, FormControlFeedback } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import './inputField.css';

export class InputField extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.onBlurEventFunction = this.onBlurEventFunction.bind(this);

    const { defaultValue = '' } = props;
    this.state = {
      value: defaultValue
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const self = this,
      { props } = self,
      {
        value: nextValue,
        defaultValue: nextDefaultValue
      } = nextProps,
      {
        value,
        defaultValue
      } = props;

    if (nextValue !== value) {
      self.setState({
        value: nextValue
      });
    }
    if (nextDefaultValue !== defaultValue) {
      self.setState({
        value: nextDefaultValue
      });
    }
  }

  getValue() {
    return this.state.value;
  }

  handleChange(e) {
    const self = this,
      {
        props
      } = self,
      {
        onChangeEvent = () => { },
        inputType
      } = props;
    let newValue = e.target.value;
    switch (inputType) {
      case 'int':
      case 'tel':
        newValue = e.target.value.replace(/[^0-9]/g, '');
        break;
      case 'float':
        newValue = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        break;
      case 'name':
        newValue = e.target.value.replace(/[^a-zA-Z]+$/, '');
        break;
      case 'email':
        newValue = e.target.value.replace(/[^a-zA-Z0-9@_\-.]+$/, '');
        break;
      case 'docNumber':
      case 'agentName':
        newValue = e.target.value.replace(/[^a-zA-Z0-9]+$/, '');
        break;
      case 'organizationCode':
        newValue = e.target.value.replace(/[^a-zA-Z0-9 ]+$/, '');
        break;
      case 'password':
        newValue = e.target.value.replace(/[^a-zA-Z0-9()`!@#$%?/-]+$/, '');
        break;
      default:
         break;
    }

    self.setState({ value: newValue });
    onChangeEvent(newValue);
  }

  onBlurEventFunction(e) {
    const {
      onBlurActEvent = () => { },
      onChangeTextEvent = () => { }
    } = this.props;
    // this.setState({value:e.target.value});
    onChangeTextEvent(e.target.value);
    onBlurActEvent(e.target.value);
  }

  render() {
    const self = this,
      {
        props,
      } = self,
      {
        frameStyle = {},
        placeholder,
        id,
        className,
        type,
        validateMessage,
        hintBlock,
        maxLength,
        disabled = false
      } = props;
    return (
      <Form.Group className={className}>
        <Form.Control
          id={id}
          className={validateMessage && validateMessage.length > 0 ? 'isError' : ''}
          type={type}
          disabled={disabled}
          value={this.state.value}
          style={frameStyle}
          placeholder={placeholder}
          onChange={this.handleChange}
          maxLength={maxLength}
          onBlur={this.onBlurEventFunction}
        >
        </Form.Control>
        {hintBlock}
        {
          validateMessage ? (
            <div className='form-control-errorText'>{validateMessage}</div>
          ) : null
        }

      </Form.Group>
    );
  }
}

InputField.propTypes = {
  label: PropTypes.any,
  frameStyle: PropTypes.object
};

export default InputField;
